import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { PermissionService } from '../services/permission.service';

export class AdminChildGuard {
  static forChild(routes: string[]) {
    @Injectable({
      providedIn: 'root',
    })
    class AdminCheck implements CanActivate {
      private readonly _permissionService = inject(PermissionService);

      canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const foundRoute = routes.find((r) => r.toLowerCase() === state.url.toLowerCase());
        return foundRoute ? this._permissionService.isAdmin() : true;
      }
    }
    return AdminCheck;
  }
}
